"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "workAsyncStorage", {
    enumerable: true,
    get: function() {
        return _workasyncstorageinstance.workAsyncStorage;
    }
});
const _workasyncstorageinstance = require("./work-async-storage-instance");

//# sourceMappingURL=work-async-storage.external.js.map